import { authGet } from './authMiddleware';

export const getCompanyAutocomplete = async (query) => {
    return authGet(`/api/Company/AutoComplete?CompanyName=${query}`);
}